<app-data-table [title]="title" [columns]="tableColumns" [filters]="tableFilters" [items]="items" [totalCount]="count"
    [page]="page" [pageSize]="pageSize" [loading]="loading" [filterValues]="tableFilterValues" [editLink]="editLink"
    [deletable]="false" [rowActions]="rowActions" (pageChange)="handlePageChange($event)"
    (search)="onTableSearch($event)" (action)="onAction($event)">
</app-data-table>

{{ error }}

<p-drawer [(visible)]="productDialog" position="right" [style]="{ width: '40%' }">
    <ng-template pTemplate="content">
        <div class="p-col-12 p-md-12">
            <p-rating [(ngModel)]="item.value1" [readonly]="true"></p-rating>
            <p [innerHTML]="item?.description"></p>
        </div>
    </ng-template>
</p-drawer>